/**
 * 비민감 UI 선호값 전용 저장소. localStorage 접근이 허용된 유일한 모듈 (ESLint로 강제).
 * 여기에는 상담 데이터·내담자 코드·식별자를 절대 저장하지 않는다. 키는 아래 목록으로 제한한다.
 */
const ALLOWED_KEYS = [
  'ui.lastTab',
  'ui.textScale',
  'ui.progressOpen',
  'doc.verbatimNotation',
  'doc.dialogueNotation',
  /** 보고서 분량 목표 (예: "8~10쪽") */
  'doc.pageTarget',
] as const;
type PrefKey = (typeof ALLOWED_KEYS)[number];

const PREFIX = 'counselai.pref.';

function assertKey(key: string): asserts key is PrefKey {
  if (!(ALLOWED_KEYS as readonly string[]).includes(key)) throw new Error(`허용되지 않은 pref 키: ${key}`);
}

export function getPref(key: PrefKey): string | null {
  assertKey(key);
  try {
    return localStorage.getItem(PREFIX + key);
  } catch {
    return null;
  }
}

export function setPref(key: PrefKey, value: string): void {
  assertKey(key);
  if (value.length > 32) throw new Error('pref 값이 너무 깁니다 (민감정보 저장 방지)');
  try {
    localStorage.setItem(PREFIX + key, value);
  } catch {
    // 저장 실패는 무시 (UI 편의 기능)
  }
}
